/**
 * PATH: packages/ui/src/kanban/components/board-view/kanbanSettingsPreferenceDefinitions.ts
 * FILE_ID: UI-KANBAN-PREFERENCES-DEFINITIONS-001
 * PURPOSE: Bind deployed Kanban scope codecs to the generic board provider.
 * ROLE IN ARCHITECTURE: Component-boundary composition root for preference domains.
 * MAIN EXPORTS: KANBAN_SETTINGS_PREFERENCE_DEFINITIONS.
 * NON-RESPONSIBILITIES: Does not hydrate, persist, render, or alter defaults.
 * NOTES FOR FUTURE AI: Schema bumps require backward-compatible coercion first.
 */

import type { KanbanSettingsPreferenceDefinitions } from '../../preferences'
import {
  DRAWER_SECTION_PREFS_SCOPE,
  coerceDrawerSectionPrefs,
} from '../card-detail/drawer-sections/drawerSectionPrefs'
import {
  CARD_TAB_LAYOUT_SCOPE,
  DEFAULT_CARD_TAB_LAYOUT,
  coerceCardTabLayout,
} from '../card-detail/drawer-sections/cardTabLayout'
import {
  CARD_FACE_DB_SCOPE,
  DEFAULT_CARD_FACE_PREFS,
  coerceCardFacePrefs,
} from './cardFacePrefs'

export const KANBAN_SETTINGS_PREFERENCE_DEFINITIONS = {
  cardFace: {
    scopeKey: CARD_FACE_DB_SCOPE,
    schemaVersion: 2,
    defaults: DEFAULT_CARD_FACE_PREFS,
    coerce: coerceCardFacePrefs,
  },
  cardTabLayout: {
    scopeKey: CARD_TAB_LAYOUT_SCOPE,
    schemaVersion: 2,
    defaults: DEFAULT_CARD_TAB_LAYOUT,
    coerce: coerceCardTabLayout,
  },
  drawerSections: {
    scopeKey: DRAWER_SECTION_PREFS_SCOPE,
    schemaVersion: 1,
    defaults: { expanded: {} },
    coerce: coerceDrawerSectionPrefs,
  },
} satisfies KanbanSettingsPreferenceDefinitions
